import { creategetRequest } from './request';
import { convertDataToProGalleryItems } from '../more/utils';
import { URL_FB_GET_HASHTAGS, URL_FB_SEARCH_HASHTAGS } from '../../constants';
import { SORT_HASHTAG_OPTIONS } from '../../constants/settingsConstants';
import store from '../../store';

const url = 'api/';

/**
 * API - Call to server to get hashtag Id
 * @param {*} hashtagName - name of hashtag
 */
export const searchHashtagApi = (hashtagName) => {
  return creategetRequest(url + URL_FB_SEARCH_HASHTAGS, {
    hashtagName: hashtagName,
  })
    .then((res) => {
      const hashtagsData = res.data.payload;
      const hashtagId = hashtagsData.id;
      hashtagName = '#' + hashtagName;

      return {
        hashtagName,
        hashtagId,
        error: hashtagsData && hashtagsData.message,
      };
    })
    .catch((err) => err);
};

/**
 * API - Get medias of hashtag from FB by hashtagId
 * @param {String} hashtagId - hashtag's id.
 * @param {*} from - if load more, "from" pagination.
 */
export const getHashtagMediaApi = (
  hashtagId,
  count,
  from = '',
  isRecent,
  headers = {},
) => {
  const { sortHashtagsFeed } = store.getState().settingsReducer;
  isRecent = isRecent || sortHashtagsFeed === SORT_HASHTAG_OPTIONS.MOST_RECENT;

  return creategetRequest(
    url + URL_FB_GET_HASHTAGS,
    {
      hashtagId,
      isRecent,
      from,
      count,
    },
    headers,
  )
    .then((res) => {
      const hashtagsData = res.data.payload;
      const pagination = hashtagsData.pagination;
      const items =
        hashtagsData && hashtagsData.data
          ? convertDataToProGalleryItems(hashtagsData.data, true)
          : [];
      return { items, pagination };
    })
    .catch((err) => err);
};
